const getDocumentSize = (documentSize) => {
  const size = documentSize ?
    documentSize > (1024 * 1024) ? Math.round(documentSize / (1024 * 1024)) : Math.round(documentSize / 1024)
    : 0;
  const sizeUnit = documentSize > (1024 * 1024) ? 'Mb' : 'Kb';
  return size + " " + sizeUnit;
};
export default getDocumentSize;